"use client";

import { createContextStore } from "@faire/web/common/hooks/ContextStore";

/**
 * We can create a Context Store with the UI state that
 * we need to keep track of.
 */
const { useStore: useAppNudgeStore, Provider: AppNudgeProvider } =
  createContextStore(
    {
      isAbandonedCartNudgeShown: true,
      hasAcknowledgedAbandonedCartNudge: false,
      isOpenWithFaireNudgeShown: true,
      hasAcknowledgedOpenWithFaireNudge: false,
      hasAcknowledgedPopupOptInNudge: false,
      isKnownReferrerNudgeShown: true,
      hasAcknowledgedKnownReferrerNudge: false,
      isReengageReferralNudgeShown: true,
      hasAcknowledgedReengageReferralNudge: false,
      hasAcknowledgedReferralAdoptionNudge: false,
      isReferralAdoptionNudgeShown: true,
    },
    { name: "AppNudgeStore" }
  );

export { useAppNudgeStore, AppNudgeProvider };
